<script>
import iEvent from './_event.js';

export default {
  name: 'event',

  mixins: [iEvent],

  data() {
    return {
      home_url: home_url,
      referrer: referrer,
      event_id: event_id,
      event: {},
      isLoading: true,
    }
  },

  template: `
    <div class="wp-block-dash-public-container" v-bind:class="{'is-loading': isLoading}">

    <div class="wp-block-cover has-accent-background-color has-background alignfull is-style-small">
      <div class="wp-block-cover__inner-container has-background">
        <div class="has-secondary-color alignwide">
          <h1 class="has-secondary-color" style="max-width: 800px;">{{ event.title }}</h1>

          <div class="wp-block-button is-style-outline">
            <div v-if="referrer">
              <input class="wp-block-button__link has-secondary-color is-style-small" type="button" value="Go back" onclick="history.back(-1)"/>
            </div>
            <div v-else>
              <a class="wp-block-button__link has-secondary-color is-style-small" :href="home_url + '/events'">Go back</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wp-block-group has-secondary-a-background-color has-background alignfull is-style-small">
      <div class="wp-block-group__inner-container">
        <div class="alignwide">
          <ul class="meta-items">
            <li>
              <i class="icon far fa-fw fa-map-marker-minus"></i>
              {{ event.location }}
            </li>
            <li>
              <i class="icon far fa-fw fa-calendar-alt"></i> {{ event.start_date | formatDate }}
              <span v-if="event.end_date"> - {{ event.end_date | formatDate }}</span>
            </li>
          </ul>

          <div v-if="event.description" style="max-width: 900px;" v-html="this.$options.filters.notesFormat(event.description)"></div>
        </div>
      </div>
    </div>

    </div>
  `,

  mounted() {
    const $this = this;

    this.getEvents();
  },

  methods: {
    getEvents: function () {
      const $this = this;

      $this.getEvent(event_id, function (event) {
        $this.event = event;
        $this.isLoading = false;
      })
    },
  },
}
</script>


